import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {dispatchEvent} from "fg-frontend/src/lib/dom";
import { getWebComponentInstance } from 'fg-frontend/src/webComponents/decorate';

import $ from "jquery";

const fragments = {
	ITEM_FILTER: '[data-fragment="GridFilterComponent.itemFilter"]',
	LINK_FILTER: '[data-fragment="GridFilterComponent.linkFilter"]',
	BTN_CONFIRM: '[data-fragment="GridFilterComponent.btnConfirm"]',
	BTN_RESET: '[data-fragment="GridFilterComponent.btnReset"]',
	BTN_ADD_NOMINAL_ROW: '[data-fragment="GridFilterComponent.btnAddNominalRow"]',
	BTN_REMOVE_NOMINAL_ROW: '[data-fragment="GridFilterComponent.btnRemoveNominalRow"]',
	BTN_SET_VALUE_CONFIRM: '[data-fragment="GridFilterComponent.btnSetValueConfirm"]',
	BTN_SET_VALUE_RESET: '[data-fragment="GridFilterComponent.btnSetValueReset"]',
	HIDDEN_INPUT_DATA_PU : '[data-fragment="GridFilterComponent.hiddenInputDataPu"]',
};

class GridFilterComponent extends WebComponent {

	constructor(props) {
		super(props);
		const {
			gridFilterItemLastActive = null,
			fixedGridFilterItemBind = null,
		} = props;
		this.state = {
			gridFilterItemLastActive,
			fixedGridFilterItemBind,
		};
	}

	didMount() {
		const {
			activeClass,
			hiddenClass,
			maxInputElements,
			itemActiveClass,
			itemAppliedClass,
			itemFilterContentClass,
			orderNominalItem,
			orderNominalItemText,
			btnReset,
			btnConfirm,
			btnSetValueConfirm,
			btnSetValueReset,
			btnAddNominalRowElement,
			btnRemoveNominalRowElement,
			filterInputs,
		} = this.props;

		this.activeClass = activeClass;
		this.hiddenClass = hiddenClass;
		this.maxInputElements = maxInputElements;
		this.itemActiveClass = itemActiveClass;
		this.itemAppliedClass = itemAppliedClass;
		this.itemFilterContentClass = itemFilterContentClass;
		this.orderNominalItem = orderNominalItem;
		this.orderNominalItemText = orderNominalItemText;
		this.table = this.element.parentElement.parentElement;
		this.tableContainer = this.table.parentElement;
		this.btnReset = btnReset;
		this.btnConfirm = btnConfirm;
		this.btnSetValueReset = btnSetValueReset;
		this.btnSetValueConfirm = btnSetValueConfirm;
		this.btnAddNominalRowElement = btnAddNominalRowElement;
		this.btnRemoveNominalRowElement = btnRemoveNominalRowElement;
		this.filterInputs = filterInputs;
		this.hiddenInputDataPu = this.element.querySelector(fragments.HIDDEN_INPUT_DATA_PU);

		const orderNominalComponentElement = document.getElementById('orderNominal');
		this.orderNominalComponent = getWebComponentInstance(orderNominalComponentElement);

		this.initMouseScrollableTable();
		this.on('click', fragments.LINK_FILTER, this.handleClickOnLinkFilter);
	}

	initMouseScrollableTable = () => {
		let _self = this;
		this.tableContainer.addEventListener('mousedown', function(e) {
			if(e.which === 1){
				_self.setState({
					touchDistance: e.clientX,
					tableContainerScrollLeft: _self.tableContainer.scrollLeft,
				});
				_self.tableContainer.addEventListener('mousemove', _self.moveScrollTableContainer);
			}
		});
		this.tableContainer.addEventListener('mouseup', function(e) {
			_self.tableContainer.removeEventListener('mousemove', _self.moveScrollTableContainer, false);
		});
		this.tableContainer.addEventListener('mouseleave', function(e) {
			_self.tableContainer.removeEventListener('mousemove', _self.moveScrollTableContainer, false);
		});
	};

	moveScrollTableContainer = (e) => {
		const {
			touchDistance,
			tableContainerScrollLeft,
		} = this.state;
		let touchEndPosition = 0;
		if(typeof(e.changedTouches) != 'undefined') {
			touchEndPosition = e.changedTouches[0].pageX;
		} else {
			touchEndPosition = e.clientX;
		}
		if(touchDistance < touchEndPosition){
			this.tableContainer.scrollLeft = tableContainerScrollLeft - (touchEndPosition - touchDistance);
		} else {
			this.tableContainer.scrollLeft = tableContainerScrollLeft + (touchDistance - touchEndPosition);
		}
	};

	handleClickOnLinkFilter = (e) => {
		e.preventDefault();
		const {
			gridFilterItemLastActive,
		} = this.state;

		let _self = this;
		const gridFilterItem = e.closestTarget.parentElement;
		const fixedGridFilterItemRef = this.fixedGridFilterItem.bind(this, e);
		const btnResetElement = gridFilterItem.querySelector(fragments.BTN_RESET);
		const btnConfirmElement = gridFilterItem.querySelector(fragments.BTN_CONFIRM);
		this.btnAddNominalRowElement = gridFilterItem.querySelector(fragments.BTN_ADD_NOMINAL_ROW);
		this.btnRemoveNominalRowElement = gridFilterItem.querySelector(fragments.BTN_REMOVE_NOMINAL_ROW);
		const btnSetValueResetElement = gridFilterItem.querySelector(fragments.BTN_SET_VALUE_RESET);
		const btnSetValueConfirmElement = gridFilterItem.querySelector(fragments.BTN_SET_VALUE_CONFIRM);
		const filterContentElement = gridFilterItem.querySelector('.'+this.itemFilterContentClass);
		const filterInputsElement = gridFilterItem.querySelectorAll('.form-control');
		const filterInputsHiddenElement = gridFilterItem.querySelectorAll('input[type="hidden"]');

		const productId = gridFilterItem.parentElement.parentElement.parentElement.getAttribute('data-product-id');
		const dataCountWidgetSelector = document.querySelector('table thead th.grid-filter__count-widget[data-product-id="'+productId+'"]');

		if(gridFilterItem.classList.contains(this.orderNominalItem)) {
			filterInputsElement[0].addEventListener('keyup', this.orderNominalFilterRows, true);
		}
		if(filterInputsElement.length > 0) {
			setTimeout(function() {
				if (!filterInputsElement[0].classList.contains('flatpickr-input')) {
				filterInputsElement[0].focus();
				}
				let filterInputsElementValue = filterInputsElement[0].value;
				if(filterInputsElementValue.length > 0){
					filterInputsElement[0].value = '';
					filterInputsElement[0].value = filterInputsElementValue;
				}

			},200);
			let i;
			for(i = 0; i < filterInputsElement.length; i++) {
				filterInputsElement[i].addEventListener('keydown', this.clickOnKey, true);
			}
		}

		this.setState({
			fixedGridFilterItemBind: fixedGridFilterItemRef,
			btnReset: btnResetElement,
			btnConfirm: btnConfirmElement,
			btnSetValueReset: btnSetValueResetElement,
			btnSetValueConfirm: btnSetValueConfirmElement,
			gridFilterItem: gridFilterItem,
			filterInputs: filterInputsElement,
			filterHiddenInputs: filterInputsHiddenElement,
		});

		if(gridFilterItem !== gridFilterItemLastActive){
			gridFilterItem.classList.add(this.itemActiveClass);
			if(!gridFilterItem.classList.contains(this.orderNominalItem)) {
				// pro ostatní tabulky
				if(btnResetElement) {
					btnResetElement.addEventListener('click', this.clickOnBtnReset);
				}
				if(btnConfirmElement) {
					btnConfirmElement.addEventListener('click', this.clickOnBtnConfirm);
				}
			} else {
				// listenery pouze pro nominálni krok - specialni chovani filtrovani a setování
				if(btnSetValueResetElement) {
					btnSetValueResetElement.addEventListener('click', this.clickOnBtnSetValueReset);
				}
				if(btnSetValueConfirmElement) {
					btnSetValueConfirmElement.addEventListener('click', this.clickOnBtnSetValueConfirm);
				}
				if(this.btnAddNominalRowElement && this.btnRemoveNominalRowElement) {
					this.btnAddNominalRowElement.addEventListener('click', this.clickOnBtnAddNominalRow);
					this.btnRemoveNominalRowElement.addEventListener('click', this.clickOnBtnRemoveNominalRow);
				}
			}

			var isIE = /MSIE|Trident/.test(window.navigator.userAgent);
			if(!isIE){
				window.addEventListener('click', this.hideAllInGridFilter, false);
			}
			window.addEventListener('scroll', fixedGridFilterItemRef, false);
			window.addEventListener('resize', fixedGridFilterItemRef, false);
			this.tableContainer.addEventListener('scroll', fixedGridFilterItemRef, false);
			this.fixedGridFilterItem(e);
			this.hideGridFilterItemLastActive();

			this.setState({
				gridFilterItemLastActive: gridFilterItem,
			});
		} else {
			gridFilterItem.classList.remove(this.itemActiveClass);
			this.setState({
				gridFilterItemLastActive: null,
			});
		}

		let dataCountWidget = 0;
		if(dataCountWidgetSelector){
			dataCountWidget = dataCountWidgetSelector.getAttribute('data-count-widget');
			// pokud je inicializovano vice widgetu klikni automaticky na pridat hodnotu
			if(parseInt(dataCountWidget) > 1) {
				for(let i = filterInputsElement.length; i < dataCountWidget; i++) {
					this.btnAddNominalRowElement.click();
				}
			}
		}

		/* inicializace tlacitek ve widgetu */
		this.initBtnInFilterWidget(dataCountWidget);

		//is touch device
		filterContentElement.addEventListener('touchstart', function(e) {
			_self.setState({
				touchDistance: e.changedTouches[0].pageX,
				tableContainerScrollLeft: _self.tableContainer.scrollLeft,
			});
			_self.tableContainer.addEventListener('touchmove', _self.moveScrollTableContainer);
		});
		filterContentElement.addEventListener('touchend', function(e) {
			_self.tableContainer.removeEventListener('touchmove', _self.moveScrollTableContainer, false);
		});
	};

	initBtnInFilterWidget = (dataCountWidget) => {
		if(this.btnAddNominalRowElement){
			if(dataCountWidget >= this.maxInputElements) {
				this.btnAddNominalRowElement.classList.add(this.hiddenClass);
			}
			if(dataCountWidget < this.maxInputElements) {
				this.btnAddNominalRowElement.classList.remove(this.hiddenClass);
			}
		}
		if(this.btnRemoveNominalRowElement){
			if(dataCountWidget > 1) {
				this.btnRemoveNominalRowElement.classList.remove(this.hiddenClass);
			}
			if(dataCountWidget === 1) {
				this.btnRemoveNominalRowElement.classList.add(this.hiddenClass);
			}
		}
	}

	clickOnKey = (e) => {
		const {
		  btnReset,
		  btnConfirm,
		  btnSetValueReset,
		  btnSetValueConfirm,
		  gridFilterItem,
		} = this.state;
		let key = e.which || e.keyCode;
		switch(key) {
			case 13:
				e.preventDefault();
				if(!gridFilterItem.classList.contains(this.orderNominalItem)) {
					btnConfirm.click();
				} else {
					btnSetValueConfirm.click();
				}
				break;
			case 27:
				e.preventDefault();
				if(!gridFilterItem.classList.contains(this.orderNominalItem)) {
					btnReset.click();
				}  else {
					btnSetValueReset.click();
				}
				break;
			default:
		}

	};

	clickOnBtnConfirm = (e) => {
		const {
			filterInputs,
		} = this.state;
		e.preventDefault();
		let firstFillFilterInput = null;
		let i;
		for(i = 0; i < filterInputs.length; i++) {
			if(filterInputs[i].value !== '') {
				firstFillFilterInput = filterInputs[i];
			}
		}
		if(firstFillFilterInput){
			let firstFillFilterInputDataPU = firstFillFilterInput.getAttribute('data-partial-update');
			if(firstFillFilterInputDataPU != null) {
				dispatchEvent(firstFillFilterInput, firstFillFilterInputDataPU,false);
			} else {
				dispatchEvent(this.hiddenInputDataPu, this.hiddenInputDataPu.getAttribute('data-partial-update'),false);
			}
		} else {
			this.hideAllInGridFilter(e, false);
		}
	};

	clickOnBtnReset = (e) => {
		const {
			filterInputs,
			filterHiddenInputs,
		} = this.state;
		e.preventDefault();

		let isAnyFilterInputFill = false;
		let i;
		for(i = 0; i < filterInputs.length; i++) {
			if(filterInputs[i].value != null) {
				if(filterInputs[i].value.length > 0) {
					isAnyFilterInputFill = true;
					break;
				}
			}
			if(filterInputs[i].nodeName === 'SELECT') {
				if(filterInputs[i].options.selectedIndex > 0){
					isAnyFilterInputFill = true;
					break;
				}
			}
		}

		if(isAnyFilterInputFill) {
			const filterAllInputs = [...filterInputs, ...filterHiddenInputs];
			for (i = 0; i < filterAllInputs.length; i++) {
				if(filterAllInputs[i].value != null) {
					if (filterAllInputs[i].value.length > 0) {
						filterAllInputs[i].value = '';
						dispatchEvent(filterAllInputs[i], 'propertychange',false);

					}
				}
			}
			if(this.hiddenInputDataPu != null) {
				dispatchEvent(this.hiddenInputDataPu, this.hiddenInputDataPu.getAttribute('data-partial-update'), false);
			} else {
				this.hideAllInGridFilter(e, true);
			}
		}
		else {
			this.hideAllInGridFilter(e, true);
		}
	};

	clickOnBtnAddNominalRow = (e) => {
		const {
			gridFilterItem,
		} = this.state;
		e.preventDefault();
		let activeRow = document.querySelector('.cursor-pointer.active').nextElementSibling;
		let productId = e.target.dataset.productId;
		let parentEl = e.target.parentElement;
		let dataCountWidgetSelector = document.querySelector('table thead th.grid-filter__count-widget[data-product-id="'+productId+'"]');
		let dataCountWidget = parseInt(dataCountWidgetSelector.getAttribute('data-count-widget'));
		if(e.isTrusted) {
			dataCountWidgetSelector.setAttribute('data-count-widget', dataCountWidget + 1);
		}
		this.initBtnInFilterWidget(dataCountWidget + 1)
		// Hodnota
		let psValueSelector = '.grid-filter__content select[data-product-id="'+productId+'"]';
		let psValueElement = activeRow.querySelectorAll(psValueSelector);
		if(psValueElement.length > 0) {
			let psValueElementParent = psValueElement[psValueElement.length-1].parentElement;
			var isIE = /MSIE|Trident/.test(window.navigator.userAgent);
			if(!isIE){
				$(psValueElement).select2('destroy');
			}
			let psValueCloned = psValueElementParent.cloneNode(true);
			let psValueClonedSelect = psValueCloned.querySelector('select');
			psValueCloned.classList.add('form-group--label-hidden');
			psValueClonedSelect.setAttribute('id', psValueElement[0].id + '-' + (psValueElement.length));
			psValueElementParent.parentNode.insertBefore(psValueCloned, psValueElementParent.nextSibling);
			if(!isIE){
				$(activeRow.querySelectorAll(psValueSelector)).select2({
					minimumResultsForSearch: Infinity
				});
			}
		}
		// Počet
		let psCountSelector = '.grid-filter__content input[data-product-id="'+productId+'"]';
		let psCountElement = activeRow.querySelectorAll(psCountSelector);
		if(psCountElement.length > 0) {
			let psCountElementParent = psCountElement[psCountElement.length-1].parentElement;
			let psCountCloned = psCountElementParent.cloneNode(true);
			let psCountClonedInput = psCountCloned.querySelector('input');
			psCountClonedInput.setAttribute('id', psCountElement[0].id + '-' + (psValueElement.length));
			psCountElementParent.parentNode.insertBefore(psCountCloned, psCountElementParent.nextSibling);
		}
		// Přidej řádky v tabulce
		if(e.isTrusted) {
			this.orderNominalComponent.addNominalRows(productId,dataCountWidget);
		}
		this.setState({
			filterInputs: gridFilterItem.querySelectorAll('.form-control'),
		})
	}

	clickOnBtnRemoveNominalRow = (e) => {
		const {
			gridFilterItem,
		} = this.state;
		e.preventDefault();
		let activeRow = document.querySelector('.cursor-pointer.active').nextElementSibling;
		let productId = e.target.dataset.productId;
		let parentEl = e.target.parentElement;
		let dataCountWidgetSelector = document.querySelector('table thead th.grid-filter__count-widget[data-product-id="'+productId+'"]');
		let dataCountWidget = parseInt(dataCountWidgetSelector.getAttribute('data-count-widget'));
		this.initBtnInFilterWidget(dataCountWidget);
		dataCountWidgetSelector.setAttribute('data-count-widget', dataCountWidget - 1);
		// Hodnota
		let removeFilterValueElement = activeRow.querySelectorAll('.grid-filter__content select[data-product-id="'+productId+'"]');
		if(removeFilterValueElement.length > 1){
			removeFilterValueElement[removeFilterValueElement.length - 1].parentElement.remove();
		}
		//Počet
		let removeFilterCountElement = activeRow.querySelectorAll('.grid-filter__content input[data-product-id="'+productId+'"]');
		if(removeFilterCountElement.length > 1) {
			removeFilterCountElement[removeFilterValueElement.length - 1].parentElement.remove();
		}
		// Odeber řádky v tabulce
		this.orderNominalComponent.removeNominalRows(productId,dataCountWidget-1);
		this.setState({
			filterInputs: gridFilterItem.querySelectorAll('.form-control'),
		})
	}

	clickOnBtnSetValueConfirm = (e) => {
		const {
			filterInputs,
		} = this.state;
		e.preventDefault();

		//trigger change input
		const orderNominalProductId = filterInputs[0].getAttribute('data-product-id');
		const orderNominalBranchId = filterInputs[0].getAttribute('data-branch-id');
		const orderNominalElementId = filterInputs[0].id;

		let orderNominalValues = [];
		for(let i = 0; i < filterInputs.length; i++) {
			if(filterInputs[i].tagName === 'SELECT') {
				orderNominalValues.push(filterInputs[i].querySelector('option:checked').getAttribute('data-nominal-id'));
			} else {
				orderNominalValues.push(filterInputs[i].value);
			}
		}

		switch(orderNominalElementId) {
			case 'filterFullName':
				this.orderNominalFilterRows();
				break;
			case 'filterEmployeeNumber':
				this.orderNominalFilterRows();
				break;
			case orderNominalElementId.startsWith('productSetValue') ? orderNominalElementId : '' :
				this.orderNominalComponent.changeProductNominalValueColumn(orderNominalValues, orderNominalProductId, orderNominalBranchId);
				break;
			case orderNominalElementId.startsWith('productSetCount') ? orderNominalElementId : '' :
					this.orderNominalComponent.changeProductNominalCountColumn(orderNominalValues, orderNominalProductId, orderNominalBranchId);
				break;
			default:
		}
		this.hideAllInGridFilter(e, true);
	};

	clickOnBtnSetValueReset = (e) => {
		const {
			filterInputs,
		} = this.state;
		e.preventDefault();

		filterInputs[0].value = '';
		this.orderNominalFilterRows();
		dispatchEvent(filterInputs[0], 'propertychange',false);
		this.hideAllInGridFilter(e, true);

	};

	orderNominalFilterRows = () => {
		const {
			gridFilterItem,
			filterInputs,
		} = this.state;
		const orderNominalBranchId = filterInputs[0].getAttribute('data-branch-id');
		const filterFullName = this.element.querySelector('#filterFullName');
		const filterEmployeeNumber = this.element.querySelector('#filterEmployeeNumber');
		if(gridFilterItem.querySelector('#filterFullName') != null){
			if(filterFullName.value !== '') {
				gridFilterItem.classList.add(this.itemAppliedClass);
			} else {
				gridFilterItem.classList.remove(this.itemAppliedClass);
			}
		}
		if(gridFilterItem.querySelector('#filterEmployeeNumber') != null){
			if(filterEmployeeNumber.value !== '') {
				gridFilterItem.classList.add(this.itemAppliedClass);
			} else {
				gridFilterItem.classList.remove(this.itemAppliedClass);
			}
		}
		this.orderNominalComponent.filterRows(filterFullName.value, filterEmployeeNumber.value, orderNominalBranchId);
	};

	fixedGridFilterItem = (linkEl) => {
		if(linkEl.closestTarget !== null) {
			const gridFilterItem = linkEl.closestTarget.parentElement;
			const gridFilterList = gridFilterItem.querySelector(fragments.LINK_FILTER);
			const gridFilterContent = gridFilterItem.querySelector('.'+this.itemFilterContentClass);
			gridFilterContent.style.top = gridFilterItem.getBoundingClientRect().top + 30 + 'px' ;
			let showAlwaysFromRight = false;
			if(gridFilterItem.classList.contains(this.orderNominalItemText)) {
				showAlwaysFromRight = true;
			}
			let itemOffsetLeftTable = gridFilterItem.getBoundingClientRect().left - this.tableContainer.getBoundingClientRect().left + this.tableContainer.scrollLeft;
			if(itemOffsetLeftTable + gridFilterContent.clientWidth < this.table.clientWidth && !showAlwaysFromRight) {
				gridFilterContent.style.left = gridFilterItem.getBoundingClientRect().left + 'px' ;
			} else {
				gridFilterContent.style.left = (gridFilterItem.getBoundingClientRect().left - gridFilterContent.clientWidth + gridFilterList.offsetWidth) + 'px';
			}
		}
	};

	hideAllInGridFilter = (e, force) => {
		const {
			fixedGridFilterItemBind,
			btnReset,
			btnConfirm,
			btnSetValueReset,
			btnSetValueConfirm,
			btnAddNominalRowElement,
			btnRemoveNominalRowElement,
			filterInputs,
			gridFilterItemLastActive,
		} = this.state;


		let isInside = false;

		if (!force) {
			if (typeof (e.currentTarget.dataset) != 'undefined') {
				if (e.currentTarget.dataset.fragment === 'GridFilterComponent.linkFilter') {
					isInside = true;
				}
			}
			if (gridFilterItemLastActive != null) {
				let isClickInside = gridFilterItemLastActive.querySelector('.grid-filter__content').contains(e.target);
				if (isClickInside) {
					isInside = true;
				}
			}
		}
		if (!isInside) {
			this.hideGridFilterItemLastActive();
			if (btnReset) {
				btnReset.removeEventListener('click', this.clickOnBtnReset, false);
			}
			if (btnConfirm) {
				btnConfirm.removeEventListener('click', this.clickOnBtnConfirm, false);
			}
			if (btnSetValueReset) {
				btnSetValueReset.removeEventListener('click', this.clickOnBtnReset, false);
			}
			if (btnSetValueConfirm) {
				btnSetValueConfirm.removeEventListener('click', this.clickOnBtnConfirm, false);
			}
			if(btnAddNominalRowElement) {
				btnAddNominalRowElement.removeEventListener('click', this.clickOnBtnAddNominalRow);
			}
			if(btnRemoveNominalRowElement) {
				btnRemoveNominalRowElement.removeEventListener('click', this.clickOnBtnRemoveNominalRow);
			}
			window.removeEventListener('scroll', fixedGridFilterItemBind, false);
			window.removeEventListener('resize', fixedGridFilterItemBind, false);
			this.tableContainer.removeEventListener('scroll', fixedGridFilterItemBind, false);
			window.removeEventListener('click', this.hideAllInGridFilter, false);
			let i;
			for(i = 0; i < filterInputs.length; i++) {
				filterInputs[i].removeEventListener('keydown', this.clickOnKey);
				filterInputs[i].removeEventListener('keyup', this.orderNominalFilterRows);
			}
		}

	};

	hideGridFilterItemLastActive = () => {
		const {
			gridFilterItemLastActive,
		} = this.state;
		if(gridFilterItemLastActive !== null) {
			gridFilterItemLastActive.classList.remove(this.itemActiveClass);
			this.setState({
				gridFilterItemLastActive: null,
			});
		}
	};

	willUnMount() {
		this.itemElements = null;
	}

	update(prevProps, prevState, inDocument) {
		const {
		} = this.state;
	}
}

GridFilterComponent.defaultProps = {
	activeClass: 'active',
	hiddenClass: 'hidden',
	maxInputElements: 5,
	itemClass: 'grid-filter__item',
	orderNominalItem: 'order-nominal__item',
	orderNominalItemText: 'order-nominal__item--text',
	itemActiveClass: 'grid-filter__item--active',
	itemAppliedClass: 'grid-filter__item--applied',
	itemFilterContentClass: 'grid-filter__content',
};

export default GridFilterComponent;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/GridFilter/GridFilterComponent.js